module.exports = __webpack_public_path__ + "static/media/freedom-park.5c8eeb56.jpg";